import * as _ from "lodash";
import {Timezone} from "../models/Timezone";
import {BaseCollection} from "./_BaseCollection";

var models = [
    {utcOffset: '-10:00', examples: 'Hawaii', dst: false, momentjs: 'Pacific/Honolulu'},
    {utcOffset: '-09:00', examples: 'Alaska', dst: true, momentjs: 'America/Anchorage'},
    {
        utcOffset: '-08:00',
        examples: 'California, Oregon, British Columbia, Mexico (Baja California)',
        dst: true,
        momentjs: 'America/Los_Angeles'
    }, {
        utcOffset: '-07:00',
        examples: 'Arizona, Mexico (Sonora), northeastern British Columbia',
        dst: false,
        momentjs: 'America/Phoenix'
    },
    {utcOffset: '-07:00', examples: 'Colorado, Alberta, Mexico (Chihuahua)', dst: true, momentjs: 'America/Denver'},
    {utcOffset: '-06:00', examples: 'El Salvador, Guatemala, Nicaragua', dst: false, momentjs: 'America/El_Salvador'},
    {utcOffset: '-06:00', examples: 'Illinois, Texas, Mexico', dst: true, momentjs: 'America/Chicago'},
    {utcOffset: '-05:00', examples: 'Columbia, Ecuador, Jamaica', dst: false, momentjs: 'America/Jamaica'},
    {
        utcOffset: '-05:00',
        examples: 'New York, Ohio, Florida, Ontario, Quebec, Cuba',
        dst: true,
        momentjs: 'America/New_York'
    },
    {utcOffset: '-04:00', examples: 'Puerto Rico, Venezuela', dst: false, momentjs: 'America/Puerto_Rico'},
    {
        utcOffset: '-04:00',
        examples: 'Nova Scotia, New Brunswick, Brazil (Mato Gosso), Chile',
        dst: true,
        momentjs: 'America/Santiago'
    }, {
        utcOffset: '-03:00',
        examples: 'Argentina, Uruguay, Brazil (Bahia, Ceará, Maranhão, Pará, Pernambuco)',
        dst: false,
        momentjs: 'America/Argentina/Buenos_Aires'
    },
    {utcOffset: '-03:00', examples: 'Brazil (Rio de Janeiro, São Paulo)', dst: true, momentjs: 'America/Sao_Paulo'},
    {utcOffset: '+00:00', examples: 'Iceland, Senegal, Ivory Coast, Ghana', dst: false, momentjs: 'Africa/Accra'},
    {utcOffset: '+00:00', examples: 'United Kingdom, Ireland, Portugal, Morocco', dst: true, momentjs: 'Europe/London'},
    {utcOffset: '+01:00', examples: 'Algeria, Angola, Gabon, Nigeria, Tunisia', dst: false, momentjs: 'Africa/Algiers'},
    {
        utcOffset: '+01:00',
        examples: 'France, Germany, Italy, Hungary, Norway, Sweden, Switzerland',
        dst: true,
        momentjs: 'Europe/Berlin'
    },
    {utcOffset: '+02:00', examples: 'Egypt, Jordan, South Africa, Zambia', dst: false, momentjs: 'Africa/Cairo'},
    {utcOffset: '+02:00', examples: 'Bulgaria, Finland, Greece, Israel, Ukraine', dst: true, momentjs: 'Europe/Athens'},
    {
        utcOffset: '+03:00',
        examples: 'Saudi Arabia, Russia (Europe), Belarus, Ethiopia, Turkey',
        dst: false,
        momentjs: 'Europe/Moscow'
    },
    {utcOffset: '+03:30', examples: 'Iran', dst: true, momentjs: 'Iran'},
    {utcOffset: '+04:00', examples: 'United Arab Emirates, Armenia, Georgia', dst: false, momentjs: 'Asia/Dubai'},
    {utcOffset: '+04:30', examples: 'Afghanistan', dst: false, momentjs: 'Asia/Kabul'},
    {utcOffset: '+05:00', examples: 'Pakistan, Uzbekistan, Kazakhstan (west)', dst: false, momentjs: 'Asia/Karachi'},
    {utcOffset: '+05:30', examples: 'India', dst: false, momentjs: 'Asia/Kolkata'},
    {utcOffset: '+06:00', examples: 'Bangladesh, Kazakhstan, Bhutan', dst: false, momentjs: 'Asia/Dhaka'},
    {utcOffset: '+07:00', examples: 'Indonesia (west), Cambodia, Laos, Thailand', dst: false, momentjs: 'Asia/Bangkok'},
    {
        utcOffset: '+08:00',
        examples: 'Western Australia, Brunei, China, Indonesia, Singapore, Taiwan',
        dst: false,
        momentjs: 'Asia/Brunei'
    },
    {utcOffset: '+09:00', examples: 'Japan, South Korea, Indonesia (east)', dst: false, momentjs: 'Japan'},
    {utcOffset: '+09:30', examples: 'Australia (Northern Territory)', dst: false, momentjs: 'Australia/North'},
    {utcOffset: '+09:30', examples: 'Australia (South Australia)', dst: true, momentjs: 'Australia/South'},
    {
        utcOffset: '+10:00',
        examples: 'Australia (Queensland), Papua New Guinea',
        dst: false,
        momentjs: 'Australia/Queensland'
    }, {
        utcOffset: '+10:00',
        examples: 'Australia (New South Wales, Tasmania, Victoria)',
        dst: true,
        momentjs: 'Australia/NSW'
    },
    {utcOffset: '+12:00', examples: 'New Zealand, Fiji', dst: true, momentjs: 'Pacific/Auckland'}
];


export class TimezoneCollection extends BaseCollection<Timezone> {

    constructor(initialModels?, options?) {
        super(initialModels, _.extend({model: Timezone}, options));

        this.add(models);
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/Timezones.ts